'use client';

import React from 'react';

const LocationMap: React.FC = () => {
  return (
    <div data-component-id="src/app/contact/components/LocationMap.tsx:7:4" data-component-path="src/app/contact/components/LocationMap.tsx" data-component-line="7" data-component-file="LocationMap.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-white%20rounded-2xl%20shadow-lg%20overflow-hidden%20border%20border-border%22%7D" className="bg-white rounded-2xl shadow-lg overflow-hidden border border-border">
      <div data-component-id="src/app/contact/components/LocationMap.tsx:8:6" data-component-path="src/app/contact/components/LocationMap.tsx" data-component-line="8" data-component-file="LocationMap.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22p-6%20lg%3Ap-8%20bg-gradient-to-r%20from-brand-primary%20to-brand-trust%22%7D" className="p-6 lg:p-8 bg-gradient-to-r from-brand-primary to-brand-trust">
        <h2 data-component-id="src/app/contact/components/LocationMap.tsx:9:8" data-component-path="src/app/contact/components/LocationMap.tsx" data-component-line="9" data-component-file="LocationMap.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-2xl%20lg%3Atext-3xl%20font-bold%20text-white%20mb-2%22%2C%22textContent%22%3A%22Visit%20Our%20Office%22%7D" className="text-2xl lg:text-3xl font-bold text-white mb-2">
          Visit Our Office
        </h2>
        <p data-component-id="src/app/contact/components/LocationMap.tsx:12:8" data-component-path="src/app/contact/components/LocationMap.tsx" data-component-line="12" data-component-file="LocationMap.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-white%2F90%22%2C%22textContent%22%3A%2273%2F74%20Swaminaran%20Nagar%20Society%2C%20Katargam%2C%20Surat%2C%20Gujarat%20395004%2C%20India%22%7D" className="text-white/90">
          73/74 Swaminaran Nagar Society, Katargam, Surat, Gujarat 395004, India
        </p>
      </div>

      <div data-component-id="src/app/contact/components/LocationMap.tsx:17:6" data-component-path="src/app/contact/components/LocationMap.tsx" data-component-line="17" data-component-file="LocationMap.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20w-full%20h-96%20lg%3Ah-%5B500px%5D%22%7D" className="relative w-full h-96 lg:h-[500px]">
        <iframe data-component-id="src/app/contact/components/LocationMap.tsx:18:8" data-component-path="src/app/contact/components/LocationMap.tsx" data-component-line="18" data-component-file="LocationMap.tsx" data-component-name="iframe" data-component-content="%7B%22elementName%22%3A%22iframe%22%2C%22src%22%3A%22https%3A%2F%2Fwww.google.com%2Fmaps%2Fembed%3Fpb%3D!1m18!1m12!1m3!1d4179.036686299125!2d72.8307432!3d21.2317027!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04ec7aaec4a69%253A0xa9968089b4858e8f!2z4Kq44KuB4Kqw4KqkIOCquOCri-Cqq-CrjeCqn-CqteCrh-CqsA!5e1!3m2!1sen!2sin!4v1764671626734!5m2!1sen!2sin%22%2C%22className%22%3A%22border-0%22%7D"
          width="100%"
          height="100%"
          loading="lazy"
          title="vidhm Solutions Office Location"
          referrerPolicy="no-referrer-when-downgrade"
          // src="https://www.google.com/maps?q=37.3861,-122.0839&z=14&output=embed"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4179.036686299125!2d72.8307432!3d21.2317027!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04ec7aaec4a69%3A0xa9968089b4858e8f!2z4Kq44KuB4Kqw4KqkIOCquOCri-Cqq-CrjeCqn-CqteCrh-CqsA!5e1!3m2!1sen!2sin!4v1764671626734!5m2!1sen!2sin"
          className="border-0"
        />
      </div>

      {/* <div className="p-6 lg:p-8 bg-muted">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <h3 className="text-sm font-semibold text-text-primary mb-2 uppercase tracking-wider">
              Parking
            </h3>
            <p className="text-text-secondary text-sm">
              Free parking available in the building garage
            </p>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold text-text-primary mb-2 uppercase tracking-wider">
              Public Transit
            </h3>
            <p className="text-text-secondary text-sm">
              Accessible via Caltrain and VTA bus routes
            </p>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold text-text-primary mb-2 uppercase tracking-wider">
              Accessibility
            </h3>
            <p className="text-text-secondary text-sm">
              Wheelchair accessible entrance and facilities
            </p>
          </div>
        </div>
      </div> */}

    </div>
  );
};

export default LocationMap;